import React, { Component } from 'react'
// Portr SDK - api class and methods
import PortrSDK from 'portr-javascript-sdk';
const portrSDK = new PortrSDK();
import { StorePreAcceptanceData } from 'src/globals';
import moment from 'moment';
import { placeholderReplace } from 'src/services/string-helper';
// images
const acceptanceComplete = require('../../images/pre-acceptance-complete.svg');
const passportIcon = require('../../images/passport-outline.svg');
const passengerIcon = require('../../images/passengers-outline.svg');
const securityIcon = require('../../images/security-outline.svg');
const ticketsIcon = require('../../images/tickets-outline.svg');

const API_PATH = process.env.REACT_APP_API_URL;
const SUBSCRIPTIONKEY = process.env.REACT_APP_SUBSCRIPTION_KEY;
const header = {
  'Ocp-Apim-Subscription-Key': SUBSCRIPTIONKEY
};
interface IProps {
  statusHandler: any;
  mergedQuestions: any;
  bookingJourneyReference: any;
  bookerUserId: string;
  language: string;
  multiLang: any;
  languageCode: string;
  handleLanguageChange: any;
  trackingData: any;
  passengerRules: any;
  isHubDrop?: boolean;
}
interface IState {
  bookingRef: string
}

export class PreAcceptanceCompleteComponent extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      bookingRef: ''
    };
  }
  componentDidMount() {
    // Get the URL
    const url = new URL(window.location.href);

    // Get the query parameter 'bookingref' from the URL
    const bookingRef = url.searchParams.get('bookingref');

    // Do something with the bookingRef, such as setting it in the component state
    this.setState({ bookingRef });

    // call api
    const request = {
      'bookingReference': bookingRef,
      'bookingJourneyReference': this.props.bookingJourneyReference,
      'userId': this.props.bookerUserId,
      'questionAnswer': this.props.mergedQuestions
    }

    portrSDK.getDataWithHeader(
      API_PATH,
      StorePreAcceptanceData,
      'post',
      null,
      request,
      null,
      header
    )
      .then((data: any) => { })
      .catch((error: any) => { });
  }
  render() {

    const { multiLang, language, trackingData, passengerRules, languageCode } = this.props;
    const airlineCode = trackingData.marketingAirlineCode || '';

    const parameters = {
      '{conditionalAcceptanceCutoffTime}': moment(trackingData.conditonalAcceptanceData.cutOffDateTime).format('HH:mm'),
      '{conditionalAcceptanceCutoffTimeDate}': moment(trackingData.conditonalAcceptanceData.cutOffDateTime).format('dddd Do MMMM')
    }

    const isConditonalAcceptance = trackingData.conditonalAcceptanceData.isConditonalAcceptance;
    const destinationCountryCode = trackingData.flightDetails.destinationCountryCode;

    const lufthansaGroupAirlines = ['LX', 'EDW', 'OS'];
    const _showUsRules = destinationCountryCode === 'US' && lufthansaGroupAirlines.includes(airlineCode) ? '_USA' : '';

    return (
      <>
        <div className='preStep preStep-complete'>
          <img src={acceptanceComplete} alt='Acceptance Complete' />
          <div className='preStep__title'>
            <h2>{multiLang[`acceptanceCompleteTitle${language}`]}</h2>
          </div>
          <div style={{ display: 'none' }} className='preStep__panel'>
            <div className='preStep__header'>
              <h2>{multiLang[`acceptanceCompletePanel2Title${language}`]}</h2>
            </div>
            <div className='preStep__body'>
              <p>{multiLang[`acceptanceCompletePanel2Text1${language}`]}</p>
              <ul>
                <li>
                  <img src={securityIcon} alt='securityIcon' />
                  <strong>
                    Swiss Post <br />
                    Something Strasse <br />
                    Swizerland <br />
                  </strong>
                  <br />
                  <p>{multiLang[`acceptanceCompletePanel2Text2${language}`]}</p>
                </li>
              </ul>
            </div>
          </div>
          <div className='preStep__panel'>
            <div className='preStep__header'>
              <h2>{multiLang[`dontForgetText${language}`]}</h2>
            </div>
            <div className='preStep__body'>
              <p>{multiLang[`acceptanceCompletePanel3Text${language}`]}</p>
              <ul>
                <li>
                  <img src={passengerIcon} alt='passportIcon' />
                  {passengerRules['passengerRules1' + _showUsRules] ? passengerRules['passengerRules1' + _showUsRules][languageCode] : passengerRules['passengerRules1'][languageCode]}
                </li>
                <li>
                  <img src={ticketsIcon} alt='ticketsIcon' />
                  {isConditonalAcceptance === true ?
                    placeholderReplace(
                      passengerRules['conditionalAcceptanceRules2' + _showUsRules] ? passengerRules['conditionalAcceptanceRules2' + _showUsRules][languageCode] : passengerRules['conditionalAcceptanceRules2'][languageCode],
                      parameters
                    )
                    : passengerRules['identityRules' + _showUsRules] ? passengerRules['identityRules' + _showUsRules][languageCode] : passengerRules['identityRules'][languageCode]}
                </li>
                <li>
                  <img src={passportIcon} alt='passportIcon' />
                  {passengerRules.phoneRule[languageCode]}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default PreAcceptanceCompleteComponent;



// WEBPACK FOOTER //
// ./src/components/pre-acceptance-complete/pre-acceptance-complete.tsx